import { PortalRequest as request } from "@/utils/request";

// 知识云搜索列表
export const getSearchZsyList = (params, data) => {
  return request({
    url: "zsy/scene-cloud/list-scene",
    method: "post",
    params,
    data,
  });
};
// 知识云相似列表
export const getSubZsyList = (params, data, id) => {
  return request({
    url: `zsy/scene-cloud/${id}/list-similar`,
    method: "post",
    params,
    data,
  });
};
// 知识云场景详情
export const getZsyInfo = (id) => {
  return request({
    url: `zsy/scene-cloud/${id}/info`,
    method: "get",
  });
};
// 知识云搜索历史
export const getSearchList = (params) => {
  return request({
    url: `zsy/scene-cloud/search-list`,
    method: "post",
    params,
  });
};
// 热搜词云
export const getWordClouds = (searchType) => {
  return request({
    url: `zsy/scene-cloud/word-clouds/${searchType}`,
    method: "post",
  });
};
// 其他推荐
export const getRecommends = (params, id) => {
  return request({
    url: `zsy/scene-cloud/other-recommend/${id}`,
    method: "post",
    params,
  });
};
